if (!customElements.get('occhio-product-video')) {
  customElements.define('occhio-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.occhioReady) return;
      this.occhioReady = true;
      this.addEventListener('toggle', event => {
        if (event.target instanceof HTMLDetailsElement && !event.target.open) {
          this.querySelectorAll('video').forEach(video => video.pause());
        }
      }, true);
    }
  });
}
